<template>
  <PageContainer title="Novo aluno">
    <Box space="medium">
      <!-- Candidato só prático só existe no Detran depois da LADV, então o cadastro comum não o encontra -->
      <div v-if="canUseIntegracaoDetran" class="aviso-ladv">
        <InformationOutline :size="20" class="aviso-icon" />
        <span>
          <strong>Candidato só prático ou novo processo de categoria?</strong>
          Ele só aparece no Detran após a emissão da LADV.
        </span>
        <Button type="button" text="Cadastrar com LADV" color="primary" :fill="false" size="small"
          @handle:click="$router.push({ name: 'emissao-ladv' })" />
      </div>

      <form class="form" @submit.prevent="openConfirmModal">
        <div class="inputs">
          <Input class="input-full" mask="###.###.###-##" :modelValue="cpf" @update:modelValue="$event => (this.cpf = $event)" legend="CPF"
            placeholder="CPF" :disabled="loading" />

          <Select class="input-full" :options="categorias" legend="Categoria pretendida" placeholder="Selecione uma categoria"
            :modelValue="categoria" @update:modelValue="$event => (this.categoria = $event)" :disabled="loading" />

          <div class="checkbox">
            <label class="input">
              <input id="importarFaturas" type="checkbox" v-model="importarFatura" :disabled="loading" />
              <span></span>
              Importar Faturas?
            </label>

            <span>Obs.: Válido p/ alunos faturados em outro CFC.</span>
          </div>
        </div>

        <div class="buttons">
          <Button type="button" @handle:click="clearInputs" text="Limpar" :fill="false" color="danger"
            :disabled="loading">
            <CloseCircleOutline :size="18" />
          </Button>
          <Button type="submit" text="Salvar aluno" color="primary" :disabled="loading">
            <Check :size="18" />
          </Button>
        </div>
      </form>
    </Box>

    <!-- Modal de Confirmação -->
    <Modal ref="confirmModal" title="Candidato">
      <div class="confirm-container">
        <h4>Confirmar cadastro do aluno com os seguintes dados:</h4>
        
        <div class="confirm-data">
          <div class="data-item">
            <strong>CPF:</strong>
            <span>{{ cpf }}</span>
          </div>
          <div class="data-item">
            <strong>Categoria:</strong>
            <span>{{ categoria }}</span>
          </div>
          <div class="data-item" v-if="importarFatura">
            <strong>Importar faturas:</strong>
            <span>Sim</span>
          </div>
        </div>

        <div class="confirm-actions">
          <Button 
            @handle:click="$refs.confirmModal.close()" 
            text="Cancelar" 
            :fill="false" 
            color="secondary"
            :disabled="loading"
          >
            <CloseCircleOutline :size="18" />
          </Button>
          <Button 
            @handle:click="handleSubmit" 
            text="Confirmar" 
            color="primary"
            :disabled="loading"
          >
            <Check :size="18" />
          </Button>
        </div>
      </div>
    </Modal>
  </PageContainer>
</template>

<script>
import PageContainer from 'core/PageContainer'
import Box from 'core/Box'
import Button from 'core/Button'
import Input from 'core/Input'
import Select from 'core/Select'
import Modal from 'core/Modal'
import urlApi from '../../router/urlApi'
import CloseCircleOutline from 'icons/CloseCircleOutline'
import Check from 'icons/Check'
import InformationOutline from 'icons/InformationOutline'
import { useAuth } from '@/composables/useAuth'

export default {
  name: 'novo-aluno-basic',
  components: {
    PageContainer,
    Box,
    Input,
    Select,
    Button,
    Modal,
    CloseCircleOutline,
    Check,
    InformationOutline,
  },
  data() {
    return {
      cpf: '',
      categoria: '',
      categorias: [
        { value: 'A', text: 'A' },
        { value: 'B', text: 'B' },
        { value: 'C', text: 'C' },
        { value: 'D', text: 'D' },
        { value: 'E', text: 'E' },
        { value: 'AB', text: 'AB' },
        { value: 'ACC', text: 'ACC' },
      ],
      importarFatura: false,
      loading: false,
      canUseIntegracaoDetran: useAuth().canUseIntegracaoDetran,

      method: 'POST',
      teorico: false,
      pratico: false,
      inclusao: false,
      renovacao: false,
      reciclagem: false,
    }
  },
  methods: {
    openConfirmModal() {
      if (!this.validateInputs()) {
        return;
      }
      
      this.$refs.confirmModal.open();
    },
    async handleSubmit() {
      this.loading = true

      if (!this.validateInputs()) {
        this.loading = false
        return
      }

      const data = {
        cpf: this.cpf,
        categoria: this.categoria,
      }

      if (this.importarFatura) data.importFaturas = this.importarFatura

      await this.$http.post(`${urlApi}/alunos/basico`, data)
        .then(async response => {
          this.$refs.confirmModal.close();
          this.toast(response.body.mensagem, 'success')
          await this.sleep(2000)
          this.$router.push({ name: 'listagem-alunos' })
        })
        .catch(err => {
          if (err.body.errors) {
            const erros = Object.values(err.body.errors).flat()

            erros.map(erro => {
              this.toast(erro)
            })
          } else if (err.body.mensagem) {
            this.toast(err.body.mensagem)
          } else {
            this.toast('Ops! não foi possivel realizar esta operação!')
          }
        })
        .finally(() => {
          this.loading = false
        })
    },
    validateInputs() {
      if (this.cpf == '' || this.cpf.length < 11) {
        this.toast('CPF inválido.')
        return false
      }

      const valoresValidos = ["A", "B", "C", "D", "E", "ACC", "AB"]

      if ((this.categoria == '' || this.categoria.length > 2) && !valoresValidos.includes(this.categoria)) {
        this.toast('Escolha uma categoria válida.')
        return false
      }

      return true
    },
    clearInputs() {
      this.cpf = ''
      this.categoria = ''
      this.importarFatura = false
    },
    toast(text, type = 'error') {
      const icon = type === 'success' ? 'fa-check-circle' : 'fa-times';
      this.$toasted.show(text, {
        icon: icon,
        position: 'top-right',
        duration: 5000,
        fullWidth: false
      })
    },
    sleep(ms) {
      return new Promise(resolve => setTimeout(resolve, ms));
    },
  },
}
</script>

<style lang="scss" scoped>
.aviso-ladv {
  margin-bottom: 2rem;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 0.75rem 1rem;
  padding: 1rem;
  border-radius: 0.5rem;
  background-color: rgba(28, 45, 90, 0.05);
  color: #1c2d5a;
  font-size: 0.875rem;

  .aviso-icon {
    flex-shrink: 0;
  }

  span {
    flex: 1 1 16rem;
  }
}

.form {
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  gap: 2.5rem;

  .inputs {
    display: flex;
    flex-wrap: wrap;
    align-items: flex-end;
    gap: 1.5rem;

    .input-full {
      flex: 1;
      max-width: 16rem;
    }

    .checkbox {
      display: flex;
      flex-direction: column;
      gap: 0.5rem;

      .input {
        margin: 0;
        display: flex;
        align-items: center;
        gap: 0.75rem;
        font-size: 0.875rem;
        font-weight: 600;
        line-height: 19.1px;
        color: #606264;

        cursor: pointer;

        input[type="checkbox"] {
          display: none;
        }

        span {
          position: relative;
          display: inline-block;
          width: 1.5rem;
          height: 1.5rem;
          border: 2px solid #DFDCDC;
          border-radius: 2px;
          background-color: #FAFAFA;
          transition: background-color 0.2s, border-color 0.2s;
        }

        input[type="checkbox"]:checked+span {
          background-color: #1C2D5A;
        }

        input[type="checkbox"]:checked+span::after {
          content: '✓';
          color: white;
          font-size: 16px;
          position: absolute;
          top: 55%;
          left: 50%;
          transform: translate(-50%, -50%);
        }
      }

      span {
        font-size: 0.625rem;
        font-weight: 600;
        line-height: 13.64px;
        color: #8F8F8F;
      }
    }
  }

  .buttons {
    align-self: flex-end;

    display: flex;
    gap: 0.5rem;
  }
}

.confirm-container {
  display: flex;
  flex-direction: column;
  gap: 2rem;

  h4 {
    color: #1c2d5a;
    font-weight: 600;
    margin: 0;
  }

  .confirm-data {
    display: flex;
    flex-direction: column;
    gap: 1rem;
    padding: 1.5rem;
    background-color: rgba(28, 45, 90, 0.05);
    border-radius: 0.5rem;

    .data-item {
      display: flex;
      justify-content: space-between;
      gap: 2rem;
      
      strong {
        font-weight: 600;
        color: #1c2d5a;
      }
      
      span {
        font-weight: 400;
      }
    }
  }

  .confirm-actions {
    display: flex;
    justify-content: flex-end;
    gap: 1rem;
    margin-top: 1rem;
  }
}
</style>
